/**
 * We want to be able to use dependency injection in Vue the same way we do in AngularJS.
 * This requires a lot of thought to get it right. But for now while AngularJS and Vue are coexisting, we can use
 * Angular's injector in Vue to get instances of things.
 *
 * Example:
 * import { getService } from '@/vue/utils/injector';
 * getService('cartService'); // Returns the CartService singleton.
 */

/**
 * @returns {injector}
 */
const getInjector = () => {
    // This is set on window in the run method in `src/epos/js/epos.js` just before the Vue app boots.
    // It is done this way instead of the window.angular.element way because the latter is not available early
    // enough.
    return window.$injector;
};

/**
 * @param {string} name
 * @returns {*}
 */
const getService = (name) => getInjector().get(name);

/**
 * This stub only exists to make tests happy.
 * In bootstrap.js this file is replaced with a mocked implementation during Jasmine tests.
 * In bootstrap-jest.js this file is replaced with a mocked implementation during Jest tests.
 *
 * @param {string} name
 * @param {*} value
 */
const addService = (name, value) => {}; // eslint-disable-line unused-imports/no-unused-vars

module.exports = {
    getInjector,
    getService,
    addService,
};
